var _rect, _path, _rect2, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMultiAward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#1D6DA5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 13H14C12.8954 13 12 13.8954 12 15V27C12 28.1046 12.8954 29 14 29H19",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 11,
    width: 8,
    height: 4,
    rx: 1,
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 13H26C27.1046 13 28 13.8954 28 15V17",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 20H20",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 24H19",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 29V26.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3882 23.0423L23.019 21.196C22.9603 20.9023 23.0364 20.5977 23.2263 20.366C23.4162 20.1343 23.7 20 23.9995 20H26.9989C27.2985 20 27.5823 20.1343 27.7722 20.366C27.9621 20.5976 28.0382 20.9022 27.9795 21.196L27.6102 23.0423C27.5615 23.2862 27.6053 23.5396 27.7333 23.7529L28.9272 25.7427C29.0199 25.8972 29.0224 26.0896 28.9336 26.2464C28.8449 26.4031 28.6786 26.5 28.4984 26.5H22.5C22.3199 26.5 22.1537 26.4031 22.0649 26.2463C21.9761 26.0896 21.9786 25.8972 22.0713 25.7427L23.2651 23.7529C23.3931 23.5396 23.437 23.2862 23.3882 23.0423V23.0423Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiAward);
export default __webpack_public_path__ + "static/media/MultiAward.b55046a2cbf8d4bd6b925750cb350474.svg";
export { ForwardRef as ReactComponent };